import React, { Fragment, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Add, Article as ArticleIcon } from "@mui/icons-material";
import CustomTable from "../templates/CustomTable";
import { articleHeader } from "../utils/HeaderData";
import { collection, getDocs, orderBy, query } from "firebase/firestore";
import { db } from "../firebase";
import { useUser } from "../components/context/UserContext";

const Article = () => {
  const navigate = useNavigate();
  const { userRole, loading } = useUser();
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    if (!loading && userRole === "operator") {
      navigate("/home");
    }
  }, [loading, userRole, navigate]);

  React.useEffect(() => {
    const fetchArticles = async () => {
      try {
        const q = query(collection(db, "articles"), orderBy("createdAt", "desc"));
        const snap = await getDocs(q);
        setArticles(
          snap.docs.map((d) => ({
            _id: d.id,
            ...d.data(),
            createdAt: d.data().createdAt?.toDate() || new Date(),
          }))
        );
      } catch (err) {
        console.error(err.message);
      }
    };
    fetchArticles();
  }, []);

  return (
    <Fragment>
      <div className="min-h-screen bg-[#f5f7fe] p-3 sm:p-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 sm:gap-0 mb-6">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-xl bg-[#fef2f2] flex items-center justify-center flex-shrink-0">
                <ArticleIcon style={{ color: "#dc2626", fontSize: 20 }} />
              </div>
              <div>
                <h1 className="text-xl sm:text-2xl font-bold text-[#000C66] font-aref">Articles</h1>
                <p className="text-gray-400 text-xs font-abel">Manage ministry articles</p>
              </div>
            </div>
            <button
              onClick={() => navigate("/create-article")}
              className="flex items-center justify-center gap-2 bg-[#000C66] text-white px-5 py-2.5 rounded-xl hover:bg-blue-900 transition font-abel text-sm font-semibold w-full sm:w-auto"
            >
              <Add style={{ fontSize: 18 }} /> Add Article
            </button>
          </div>

          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
            <CustomTable
              headers={articleHeader}
              data={articles}
              editPath="/update-article"
              deletePath="/delete-article"
            />
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Article;
